export interface IGetLinkProps {
  url: string
  text?: string
}

export const getTwitterShareLink = ({ url, text = '' }: IGetLinkProps) => {
  const baseUrl = 'https://twitter.com/intent/tweet'

  return `${baseUrl}?url=${url}&text=${text}`
}

export const getFacebookShareLink = ({ url, text = '' }: IGetLinkProps) => {
  const baseUrl = 'https://www.facebook.com/sharer/sharer.php'

  return `${baseUrl}?u=${url}&quote=${text}`
}

export const getLinkedInShareLink = ({ url, text = '' }: IGetLinkProps) => {
  const baseUrl = 'https://linkedin.com/shareArticle'

  return `${baseUrl}?url=${url}&mini=true&title=${text}`
}
